// Call All API runs only for exactly one Tenant, one Company, one BU and one API group (owner,
// 2026-10-19: each BU is called separately). The API enforces the same rule with HTTP 400.
export const CALL_ALL_SCOPE_KEYS = ['tenant_id', 'company_id', 'bu_id', 'group_id'];

export const CALL_ALL_SCOPE_TOOLTIP =
  'Select one Tenant, one Company, one BU and one API group to call all APIs.';

// The column-filter reset stores the header's tenant/company/BU as single values, while the
// header and column filters otherwise store arrays; the API expects arrays.
const asArray = (value: any): any[] | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }
  return Array.isArray(value) ? value : [value];
};

const isSingleId = (value: any): boolean => {
  const values = asArray(value);
  if (!values || values.length !== 1) {
    return false;
  }
  const id = values[0];
  if (typeof id === 'number') {
    return Number.isInteger(id) && id > 0;
  }
  return typeof id === 'string' && /^[1-9]\d*$/.test(id.trim());
};

export const isCallAllScopeValid = (filterKeys: Record<string, any> | null | undefined): boolean =>
  !!filterKeys && CALL_ALL_SCOPE_KEYS.every((key) => isSingleId(filterKeys[key]));

// Scope values as arrays; every other filter is passed through untouched.
export const normalizeCallAllFilterKeys = (
  filterKeys: Record<string, any>
): Record<string, any> => {
  const result = { ...filterKeys };
  CALL_ALL_SCOPE_KEYS.forEach((key) => {
    if (key in result && result[key] !== undefined && result[key] !== null) {
      result[key] = asArray(result[key]);
    }
  });
  return result;
};
